import { MyInstituteState } from './my-institute-state';
import { Selector } from "@ngxs/store";
import { MyInstituteStateModel } from "./my-institute-state-model";

export class MyInstitutesSelectors {
  @Selector([MyInstituteState])
  static getMyInstitute(state: MyInstituteStateModel) {
    return state;
  }

  @Selector([MyInstituteState])
  static getMyInstituteById(state: MyInstituteStateModel, id: string) {
    return state.items.find(item => item.id === id);
  }
}
